
export class Features {
    public static ALTERNATIVES_SYSTEM = 'alt_sys';
    public static CO2_AUSWERTUNG_ANTEIL_STANDORTE = 'co2_ausw_anteil_standorte';
    public static CO2_SCOPE3_REISEN_TITEL = 'co3_s3_reisen_titel';
    public static STANDORT_GRUPPEN = 'standort_gruppen';
    public static DV_GEWERKEGRUPPEN = 'dv_gewerkegruppen';
}